import styles from './ServicesPreview.module.css'

function ServicesPreview() {
    const services = [
        {
            id: 1,
            icon: '📊',
            title: 'Soluciones Contables',
            description: 'Optimiza tu contabilidad con herramientas inteligentes de conciliación y análisis financiero.'
        },
        {
            id: 2,
            icon: '🤖',
            title: 'Inteligencia Artificial',
            description: 'Automatiza procesos complejos con IA que aprende y se adapta a las necesidades de tu empresa.'
        },
        {
            id: 3,
            icon: '⚡',
            title: 'Agentes IA Personalizados',
            description: 'Desarrollamos agentes de IA a medida que resuelven desafíos específicos de tu negocio.'
        },
        {
            id: 4,
            icon: '🔄',
            title: 'Automatización de Procesos',
            description: 'Elimina tareas repetitivas y libera tiempo para enfocarte en lo estratégico.'
        }
    ]

    return (
        <section className={styles.services}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Nuestros Servicios</h2>
                    <p className={styles.subtitle}>
                        Soluciones tecnológicas diseñadas para transformar tu empresa
                    </p>
                </div>

                <div className={styles.grid}>
                    {services.map((service) => (
                        <div key={service.id} className={styles.card}>
                            <div className={styles.icon}>{service.icon}</div>
                            <h3 className={styles.cardTitle}>{service.title}</h3>
                            <p className={styles.cardDescription}>{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default ServicesPreview
